// Override Settings
var boostPFSInstantSearchConfig = {
	search: {
      suggestionMobileStyle: 'style1'
	}
};

(function() {
	BoostPFS.inject(this);

	// Customize style of Suggestion box
	SearchInput.prototype.customizeInstantSearch = function() {
		var suggestionElement = this.$uiMenuElement;
		var searchElement = this.$element;
		var searchBoxId = this.id;
	};
  
  	InstantSearchMobile.prototype.afterShowSearchBoxMobile = function() {
	  	// Override this method for customization
      	
	}
    
    var instantSearchInit = InstantSearch.prototype.init;

    InstantSearch.prototype.init = function() {  
      jQ('input[name="' + Settings.getSettingValue('search.termKey') + '"]').each(function(i) {
        if (!jQ(this)[0].hasAttribute('data-no-bc-search')) {
          var clone = jQ(this).clone();
          jQ(this).replaceWith(clone);
        }
      });

      instantSearchInit.call(this);
    }    

    var bindEvents = InstantSearchMobile.prototype.bindEvents;

    InstantSearchMobile.prototype.bindEvents = function() {
        bindEvents.call(this);

        var self = this;
        var clone = jQ('a.js-search-header').clone();
      	jQ('a.js-search-header').replaceWith(clone);

        jQ('a.js-search-header').click(function(e) {
          e.stopPropagation();
          e.preventDefault();
          self.openSuggestionMobile()
        });
    }    
})();